import React from "react";
import ReactDOM from "react-dom";
import "./assets/theme/index.css";
import 'react-notifications-component/dist/theme.css'
import App from './App';

ReactDOM.render(<App/>, document.getElementById('root'));
